import './bootstrap';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
import general from './containers/general';

function app() {
  general();

  const application = Application.start();
  const context = require.context('./controllers', true, /\.js$/);
  application.load(definitionsFromContext(context));
}

app();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(() => {
      // Registration was successful
    }, (err) => {
      console.log('ServiceWorker registration failed: ', err); // eslint-disable-line
    });
  });
}
